module.exports = __webpack_public_path__ + "img/dataSecurity.4785ada5.png";